'use client';

import { createContext, useCallback, useContext, useMemo, useState } from "react";

const PublicProviderInteractionContext = createContext({
    contactMobile: false,
    setContactMobile: () => {},
    openContactMobile: () => {},
    formFocusTrigger: 0,
    triggerFormFocus: () => {},
});

export function PublicProviderInteractionProvider({ children }) {
    const [contactMobile, setContactMobile] = useState(false);
    const [formFocusTrigger, setFormFocusTrigger] = useState(0);

    const triggerFormFocus = useCallback(() => setFormFocusTrigger(v => v + 1), []);
    const openContactMobile = useCallback(() => {
        setContactMobile(true);
        triggerFormFocus();
    }, [triggerFormFocus]);

    const value = useMemo(() => ({
        contactMobile,
        setContactMobile,
        openContactMobile,
        formFocusTrigger,
        triggerFormFocus,
    }), [contactMobile, formFocusTrigger, openContactMobile, triggerFormFocus]);

    return (
        <PublicProviderInteractionContext.Provider value={value}>
            {children}
        </PublicProviderInteractionContext.Provider>
    );
}

export function usePublicProviderInteraction() {
    return useContext(PublicProviderInteractionContext);
}
